import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';

export class ClientSelectClass extends Component {
    constructor(props) {
        super(props);

        this._handleSelectedOptionChange = this._handleSelectedOptionChange.bind(this);
    }

    componentDidMount() {
        this.setState({
            selectedOption: this.props.selectedOption
        })
    }

    _handleSelectedOptionChange(event) {
        const selectedClientId = event.target.value;
        const selectedOption = Array.from(event.target.options).find((option) => option.value === selectedClientId);
        const selectedClientName = selectedOption.text;

        this.props.onClientChange(selectedClientId, selectedClientName)
    }

    _isRequiredValue() {
        return this.props.required === true;
    }

    render() {
        const { t } = this.props;
        if (this.props.allClients !== null) {
            return (
                <select name="client"
                        onChange={this._handleSelectedOptionChange}
                        value={this.props.selectedOption}
                        required={this._isRequiredValue()}
                >
                    <option key='empty-option' value=''>-----</option>
                    {this.props.allClients.map((option) =>
                        <option key={option.id} value={option.id}>{option.name}</option>
                    )}
                </select>
            )
        } else {
            return <p>{t('common.loading')}</p>
        }
    }
}

export const ClientSelect = withTranslation()(ClientSelectClass);
export default ClientSelect;
